import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import UserInfo from "components/UserInfo";

import IntlMessages from "util/IntlMessages";
import CustomScrollbars from "util/CustomScrollbars";
import SidenavLogo from "components/SidenavLogo";

import GeneralApi from "../../app/generalApi";
const apiGeneral = new GeneralApi();

class SidenavContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: [],
      loading: false,
    };

    this.getMenu = this.getMenu.bind(this);
  }

  async componentDidMount() {
    this.getMenu();

    const { history } = this.props;
    const that = this;
    const pathname = `#${history.location.pathname}`; // get current path

    const subMenuLi = document.querySelectorAll(".sub-menu > li");
    for (let i = 0; i < subMenuLi.length; i++) {
      subMenuLi[i].onclick = function (event) {
        event.stopPropagation();
      };
    }

    const menuLi = document.getElementsByClassName("menu");
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, "li");
          if (
            menuLi[j] !== this &&
            (parentLi === null || !parentLi.classList.contains("open"))
          ) {
            menuLi[j].classList.remove("open");
          }
        }
        this.classList.toggle("open");
        event.stopPropagation();
      };
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) {}
  }

  getMenu() {
    apiGeneral
      .getMenu()
      .then((result) => {
        //const aux = Object.keys(result).map(k => result[k]);
        let aux = [];

        result.forEach(function (data) {
          let obj = data.val();
          obj._id = data.key;
          aux.push(obj);
        });

        if (aux) {
          aux = aux.sort((a, b) =>
            a.order > b.order ? 1 : b.order > a.order ? -1 : 0
          );
        }

        this.setState({ menu: aux ? aux : new Array(), loading: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ menu: [], loading: false });
      });
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      [
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector",
      ].some(function (fn) {
        if (typeof document.body[fn] == "function") {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {}

    return null;
  }

  render() {
    const { menu } = this.state;
    return (
      <CustomScrollbars
        className="scrollbar"
        style={{
          height: "calc(100vh)",
          maxWidth: "100%",
          position: "unset",
          backgroundColor: apiGeneral.getBackgroundColor(),
        }}
      >
        <SidenavLogo style={{ maxWidth: "100%" }} />
        <div
          style={{
            paddingTop: "24px",
            paddingLeft: "24px",
            paddingRight: "24px",
            paddingBottom: "24px",
            textAlign: "center",
            maxWidth: "100%",
          }}
        >
          <UserInfo
            forceBlackButtons={!apiGeneral.isSpain() ? true : false}
            darkBg={true}
            visible={true}
            navigateTo={() => this.props.history.push("/app/inicio/register")}
          />
        </div>

        <ul
          className="nav-menu"
          style={{ backgroundColor: apiGeneral.getBackgroundColor() }}
        >
          {menu.map((n) => {
            if (
              n.title.toLowerCase() == "plan amigo" &&
              apiGeneral.isInmovilla()
            ) {
              return null;
            }

            if (
              n.title.toLowerCase() == "regala suscripción" &&
              apiGeneral.isInmovilla()
            ) {
              return null;
            }

            return (
              <li className="menu no-arrow" key={n._id}>
                <NavLink
                  className={apiGeneral.getMenuStyle()}
                  to={`/app/${n.url}`}
                >
                  <i className={`${n.icon}`} aria-hidden="true"></i>

                  {!n.isNew && (
                    <span className="nav-text">{`${n.title}`} </span>
                  )}

                  {n.isNew && (
                    <b>
                      <span className="nav-text">{`${n.title}`} </span>
                    </b>
                  )}

                  {n.isNew && (
                    <span
                      className="nav-text"
                      style={{
                        color: apiGeneral.isSpain() ? "gold" : "#000",
                        fontSize: "smaller",
                      }}
                    >
                      ¡Nuevo!
                    </span>
                  )}
                </NavLink>
              </li>
            );
          })}

          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </ul>
      </CustomScrollbars>
    );
  }
}

export default withRouter(SidenavContent);



// WEBPACK FOOTER //
// ./containers/SideNav/SidenavContent.js